/**
 * Dispara evento para exibir toast de atualização do PWA.
 * Chamado por registerSW quando há nova versão disponível.
 * O botão "Atualizar" usa getUpdateSW() para chamar skipWaiting e recarregar.
 */

const SW_NEED_REFRESH_EVENT = 'sw-need-refresh'
const SW_NEED_REFRESH_FLAG = 'sw-need-refresh'

export type UpdateSWFn = (reloadPage?: boolean) => Promise<void>

export const dispatchSwNeedRefresh = () => {
  sessionStorage.setItem(SW_NEED_REFRESH_FLAG, '1')
  window.dispatchEvent(new CustomEvent(SW_NEED_REFRESH_EVENT))
}

export { SW_NEED_REFRESH_EVENT, SW_NEED_REFRESH_FLAG }
